import React from 'react';
import Nav from '../components/Nav';
import Hero from '../components/Hero';
import Calculator from '../components/Calculator';
import Platform from '../components/Platform';
import VoiceAI from '../components/VoiceAI';
import Upsell from '../components/Upsell';
import Languages from '../components/Languages';
import Kiosk from '../components/Kiosk';
import Admin from '../components/Admin';
import HowItWorks from '../components/HowItWorks';
import FAQ from '../components/FAQ';
import DemoCTA from '../components/DemoCTA';
import Footer from '../components/Footer';
import { useReveal } from '../hooks';
import '../styles/site.css';

const HomePage = () => {
  useReveal();
  return (
    <div className="site">
      <Nav />
      <main>
        <Hero />
        <Calculator />
        <Platform />
        <VoiceAI />
        <Upsell />
        <Languages />
        <Kiosk />
        <Admin />
        <HowItWorks />
        <FAQ />
        <DemoCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
